import React from 'react'

import '../Estilos/EstiloSap.css';
import 'bootstrap/dist/css/bootstrap.css';
import '../New Template/Botones.css';
import '../New Template/Formularios1.css';
import Swal from 'sweetalert2';
import ConsecutivosTabla from './ConsecutivosTabla';
import withReactContent from 'sweetalert2-react-content';
import { ListaSucursales, ListaTerminales } from '../Comunes/Listas';

const Zona = (props) => {

    const MySwal = withReactContent(Swal);

    const NuevoConsecutivo = async (Gestion) => {
        let Nombre = Gestion === 'FAC' ? 'Factura Electrónica' :
            Gestion === 'TIQ' ? 'Tiquete Electrónico' :
                Gestion === 'EXP' ? 'Factura Exportación' :
                    Gestion === 'NC' ? 'Nota Crédito' :
                        Gestion === 'ND' ? 'Nota Débito' :
                            Gestion === 'FEC' ? 'Factura Electrónica Compra' :
                                Gestion === 'MR' ? 'Confirmación Compra' :
                                    Gestion === 'COT' ? 'Cotización' : '';


        const { value: formValues } = await MySwal.fire({
            title: 'Nuevo Consecutivo ' + Nombre,
            html: (
                <div>

                    <select id="AgrSucursal" name="AgrSucursal" className="form-group">
                        {ListaSucursales.map((option, i) => (
                            <option key={i} value={option.value}>{option.span}</option>
                        ))}</select>
                    <select id="AgrTerminal" name="AgrTerminal" className="form-group" >
                        {ListaTerminales.map((option, i) => (
                            <option key={i} value={option.value}>{option.span}</option>
                        ))}</select>

                    <input id="swal-input2" autoComplete='off' className="swal2-input" placeholder="Siguiente" />
                </div>
            ),
            focusConfirm: false,
            preConfirm: () => {
                const COD_Sucursal = document.getElementById('AgrSucursal').value;
                const COD_Terminal = document.getElementById('AgrTerminal').value;
                const Siguiente = document.getElementById('swal-input2').value;
                if (!COD_Sucursal || !COD_Terminal || !Siguiente) {
                    Swal.showValidationMessage('Todos los campos son requeridos');
                    return false;
                }
                return { Tipo: Gestion, Sucursal: COD_Sucursal, Terminal: COD_Terminal, Siguiente: Siguiente };
            }
        });

        if (formValues) {
            props.AgregarConsecutivo(formValues)

        }

    }

    return <>

        <h4>Consecutivos</h4>

        <div className="row" style={{ paddingLeft: '10px' }} >
            <div className="col-50" style={{ backgroundColor: 'lightblue', border: '1px solid grey', paddingTop: '5px' }} >
                <div className='row'>
                    <div className='col-50'>
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Factura Electrónica</span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoFactura" onClick={() => NuevoConsecutivo('FAC')} name="NuevoFactura">+ Factura</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"FAC"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />
            </div>
            <div className="col-50" style={{ backgroundColor: '#97c6aa', border: '1px solid grey', paddingTop: '5px', width: '90%' }}>
                <div className='row'>
                    <div className='col-50'>
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Tiquete Electrónico</span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoTiquete" onClick={() => NuevoConsecutivo('TIQ')} name="NuevoTiquete">+ Tiquete</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"TIQ"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />
            </div>

        </div>


        <div className="row" style={{ paddingLeft: '10px' }}>
            <div className="col-50" style={{ backgroundColor: 'lightblue', border: '1px solid grey', paddingTop: '5px' }}>
                <div className='row'>
                    <div className='col-50' >
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Factura Exportación</span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoExporta" onClick={() => NuevoConsecutivo('EXP')} name="NuevoExporta">+ Exportación</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"EXP"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />
            </div>
            <div className="col-50" style={{ backgroundColor: '#97c6aa', border: '1px solid grey', paddingTop: '5px', width: '90%' }}>
                <div className='row'>
                    <div className='col-50'>
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Nota Crédito</span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoNC" onClick={() => NuevoConsecutivo('NC')} name="NuevoNC">+ Nota Crédito</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"NC"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />

            </div>
        </div>





        <div className="row" style={{ paddingLeft: '10px' }} >
            <div className="col-50" style={{ backgroundColor: 'lightblue', border: '1px solid grey', paddingTop: '5px' }} >
                <div className='row'>
                    <div className='col-50'>
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Nota Débito</span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoND" onClick={() => NuevoConsecutivo('ND')} name="NuevoND">+ Nota Débito</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"ND"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />
            </div>
            <div className="col-50" style={{ backgroundColor: '#97c6aa', border: '1px solid grey', paddingTop: '5px', width: '90%' }}>
                <div className='row' >
                    <div className='col-50'>
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Factura Electrónica Compra </span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoFEC" onClick={() => NuevoConsecutivo('FEC')} name="NuevoFEC">+ FEC</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"FEC"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />
            </div>
        </div>


        <div className="row" style={{ paddingLeft: '10px' }}>
            <div className="col-50" style={{ backgroundColor: 'lightblue', border: '1px solid grey', paddingTop: '5px' }} >
                <div className='row'>
                    <div className='col-50'>
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Confirmación Compra</span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoConfirma" onClick={() => NuevoConsecutivo('MR')} name="NuevoConfirma">+ Conf. Compra</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"MR"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />
            </div>
            <div className="col-50" style={{ backgroundColor: '#97c6aa', border: '1px solid grey', paddingTop: '5px', width: '90%' }}>
                <div className='row' >
                    <div className='col-50'>
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Cotización </span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoCOT" onClick={() => NuevoConsecutivo('COT')} name="NuevoFEC">+ Cotización</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"COT"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />
            </div>
        </div>


        <div className="row" style={{ paddingLeft: '10px' }}>
            <div className="col-50" style={{ backgroundColor: 'lightblue', border: '1px solid grey', paddingTop: '5px' }} >
                <div className='row'>
                    <div className='col-50'>
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Recibo Pago Electrónico</span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoREP" onClick={() => NuevoConsecutivo('REP')} name="NuevoREP">+ REC</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"REP"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />
            </div>
            <div className="col-50" style={{ backgroundColor: '#97c6aa', border: '1px solid grey', paddingTop: '5px', width: '90%' }}>
                <div className='row' >
                    <div className='col-50'>
                        <span style={{ fontWeight: 'bold' }} className="col-form-span" >Pedido </span>
                    </div>
                    <div className='col-50'>
                        <button id="NuevoPED" onClick={() => NuevoConsecutivo('PED')} name="NuevoPED">+ Pedido</button>
                    </div>
                </div>
                <ConsecutivosTabla gestion={"PED"} EliminarConsecutivo={props.EliminarConsecutivo} ActualizarConsecutivo={props.ActualizarConsecutivo} LosConsecutivos={props.LosConsecutivos} />
            </div>
        </div>


    </>
}
export default Zona;